import { combineReducers } from "@reduxjs/toolkit";
// slice 
import authReducer from "./features/slices/authSlice/authSlice";
import ThemeModeReducer from "./features/slices/ThemeModeSlice/ThemeModeSlice";
import chatSliceReducer from "./features/slices/chatSlice/chatSlice";

// api 
import { AdminAuthorizedApi } from "./services/AdminAuthorizedApi/AdminAuthorizedApi";
import { AdminAuthApi } from "./services/AdminAuthApi/AdminAuthApi";
import { UserApi } from "./services/UserApi/UserApi";
import { AdminApi } from "./services/AdminApi/AdminApi";
import { ChatApi } from "./services/ChatApi/ChatApi";


export const rootReducers = combineReducers({
  auth: authReducer,
  ThemeMode: ThemeModeReducer,
  chat: chatSliceReducer,

  // ////// ad,om Authorized api call
  [AdminAuthorizedApi.reducerPath]: AdminAuthorizedApi.reducer,

  // ////// User  api call
  [AdminAuthApi.reducerPath]: AdminAuthApi.reducer,
  [UserApi.reducerPath]: UserApi.reducer,
  [AdminApi.reducerPath]: AdminApi.reducer,


  // ////// chat  api call
  [ChatApi.reducerPath]: ChatApi.reducer,



});

export const AllMiddleware = [
  AdminAuthorizedApi.middleware,
  AdminAuthApi.middleware,
  UserApi.middleware,
  AdminApi.middleware,
  ChatApi.middleware,
];

